<template>
  <el-dialog :title="fa(readOnly ? 'view' : 'title')" :visible.sync="visible" width="540px" append-to-body
    :close-on-click-modal="false" :close-on-press-escape="!submitting" :show-close="!submitting" :before-close="close">
    <div v-loading="loading">
      <el-form label-width="130px">
        <el-form-item :label="fa('studentName')">{{ detail.studentName }}</el-form-item>
        <el-form-item :label="fa('accountNo')">{{ detail.accountNo }}</el-form-item>
        <el-form-item v-if="source !== 1" :label="fa('school')">{{ detail.schoolId }} - {{ detail.schoolName }}</el-form-item>
        <el-form-item :label="fa('face')">
          <el-image v-if="detail.faceImg" :src="detail.faceImg" :preview-src-list="[detail.faceImg]" @load="imageReady=true" @error="imageReady=false" fit="contain" style="width:200px;height:220px">
            <div slot="error">{{ fa('photoError') }}</div>
          </el-image><span v-else>{{ fa('noPhoto') }}</span>
        </el-form-item>
        <el-form-item v-if="!readOnly" :label="fa('result')" required>
          <el-select v-model="result" :placeholder="fa('choose')" :disabled="submitting || uncertain">
            <el-option :value="1" :label="fa(source === 2 ? 'student' : 'self')" />
            <el-option :value="2" :label="fa(source === 2 ? 'adult' : 'notSelf')" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button :disabled="submitting" @click="visible=false">{{ fa('cancel') }}</el-button>
      <el-button v-if="!readOnly" type="primary" :loading="submitting" :disabled="loading || !detail.faceImg || !imageReady" @click="submit">{{ fa('submit') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from '@/api/faceAgeAudit'
import words from './i18n'
const requestId = () => {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, x => x.toString(16).padStart(2,'0')).join('')
}
export default {
  name: 'FaceAgeAuditDialog', mixins: [words], props: { source: {type:Number,required:true} },
  data() { return {visible:false, loading:false, submitting:false, readOnly:false, uncertain:false, imageReady:false, detail:{}, result:null, requestId:''} },
  methods: {
    close(done) { if (!this.submitting) done() },
    async open(row, readOnly=false) {
      if (this.loading || this.submitting) return
      this.detail={}; this.imageReady=false; this.result=null; this.uncertain=false; this.requestId=requestId(); this.readOnly=readOnly; this.visible=true; this.loading=true
      try { this.detail=await api.detail({accountId:row.accountId}) }
      catch(e) { this.$message.error(e.message || this.fa('error')); this.visible=false }
      finally { this.loading=false }
    },
    async submit() {
      if (this.submitting || this.loading) return
      if (this.result === null) return this.$message.warning(this.fa('required'))
      this.submitting=true
      try {
        await this.$confirm(this.fa(this.result===2 ? 'rejectConfirm' : this.source===1 ? 'dealerConfirm' : 'approveConfirm'), this.fa('title'),
          {type:'warning',confirmButtonText:this.fa('submit'),cancelButtonText:this.fa('cancel')})
        // Keep request ID and decision after uncertain outcomes; upstream deduplicates retries.
        this.uncertain=true
        await api.submit({requestId:this.requestId, accountId:this.detail.accountId,
          expectedStatus:this.detail.bindStatus, auditResult:this.result})
        this.$message.success(this.fa('success')); this.visible=false; this.$emit('success')
      } catch(e) { if(e!=='cancel' && e!=='close') this.$message.error(e.message || this.fa('error')) }
      finally { this.submitting=false }
    }
  }
}
</script>
